const __WEBPACK_NAMESPACE_OBJECT__ = require("@material-ui/icons/Close");